import {
  FontIcon,
  FontIconPositions,
  FontIcons,
  ShimmerLoader,
  brandfolderColorPalette,
} from '@brandfolder/react';
import { Trans } from '@lingui/macro';
import React, { FunctionComponent, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import styled from 'styled-components';

import { ImageOverlay } from '../common/ImageOverlay';

const FaceCardWrapper = styled.div`
  box-shadow: 1px 2px 6px 0 rgba(0, 0, 0, 0.09);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .default-image {
    background-color: ${brandfolderColorPalette.neutrals[200]};
    height: calc(100% - 52px);
  }

  .bf-loader__shimmer {
    width: 100%;

    &--br {
      height: 250px;
      width: 100%;
    }
  }

`;
const ImageWrapper = styled.div`
  cursor: pointer;
  display: flex;
  position: relative;
  width: 100%;
`;
const LabelWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 52px;
  padding: 0 16px;
`;
const CardImage = styled.img`
  height: 100%;
  min-height: 210px;
  width: 100%;
`;
const DefaultImage = styled.div`
  align-items: center;
  color: ${brandfolderColorPalette.neutrals[500]};
  display: flex; 
  height: 100%;
  justify-content: center;
  min-height: 210px;
`;
const TagPersonLinkIcon = styled(FontIcon)`
  vertical-align: middle;
`;
const TagPersonLinkText = styled.span`
  color: ${brandfolderColorPalette.primary[700]};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  vertical-align: middle;

  &:hover {
    color: #314CA9;
  }
`;
const Label = styled.div`
  color: ${brandfolderColorPalette.neutrals[700]};
  font-size: 14px;
  font-weight: 450;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export interface FaceCardProps {
  id: string;
  imageUrl: string;
  label?: string;
  loading?: boolean;
}

export const FaceCard: FunctionComponent<FaceCardProps> = ({
  id,
  imageUrl,
  label = undefined,
  loading = true,
}) => {
  const [hasImageError, setHasImageError] = useState(false);
  const thumbnail = hasImageError ? null : imageUrl;
  const location = useLocation();

  return (
    <FaceCardWrapper>
      {!loading ? (
        <>
          <ImageWrapper className={hasImageError && 'default-image'}>
            <ImageOverlay
              buttonText={!label ? 'Tag person' : 'View person'}
              linkTo={id}
              locationState={{
                label,
                thumbnail,
                prevRoute: `${location.pathname}${location.search}`
              }}
            >
              {!hasImageError ? (
                <CardImage
                  alt="person"
                  onError={(): void => setHasImageError(true)}
                  src={imageUrl}
                />
              ) : (
                <DefaultImage>
                  <FontIcon
                    icon={FontIcons.UserFilled}
                    iconSize={68}
                    title="default image"
                  />
                </DefaultImage>
              )}
            </ImageOverlay>
          </ImageWrapper>
          <LabelWrapper>
            {!label ? (
              <Link state={{ label, thumbnail }} to={id}>
                <TagPersonLinkIcon
                  icon={FontIcons.Tag}
                  iconSize={14}
                  position={FontIconPositions.Left}
                />
                <TagPersonLinkText>
                  <Trans>Tag person</Trans>
                </TagPersonLinkText>
              </Link>
            ) : (
              <Label>{label}</Label>
            )}
          </LabelWrapper>
        </>
      ) : (
        <ShimmerLoader />
      )}
    </FaceCardWrapper>
  );
};
